// @flow
import { last, take } from 'lodash'
import { LOCIZE_NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-PROGRAM-TYPE`

export default function ProgramTypeFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const isActive = !!filters.selectedProgramTypes.length
  const selectedProgramTypes = filters.selectedProgramTypes.sort()

  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  function label() {
    if (isActive) {
      if (selectedProgramTypes.length > 2) {
        const isLastType = last(selectedProgramTypes)
        const lastType = isLastType !== undefined ? isLastType : null
        const head = take(selectedProgramTypes, selectedProgramTypes.length - 1)
          .map(programType => labelForProgramTypeValue(programType))
          .join(', ')
        const tail = labelForProgramTypeValue(lastType)
        return t(`${PRE}-LABEL-ACTIVE`, { head, tail })
      } else if (selectedProgramTypes.length === 2) {
        const head = labelForProgramTypeValue(selectedProgramTypes[0])
        const tail = labelForProgramTypeValue(selectedProgramTypes[1])
        return t(`${PRE}-LABEL-ACTIVE`, { head, tail })
      }
      return `${labelForProgramTypeValue(selectedProgramTypes[0])}`
    }

    if (whitelabel.networkAbbr === 'NM') return t(`${PRE}-LABEL-NM`)

    return t(`${PRE}-LABEL`)
  }

  function labelForProgramTypeValue(value: string | null) {
    if (!value) return ''

    const PRE_ORIGINAL = 'ONBOARDING-LICENSING-PROGRAM-TYPE'

    switch (value) {
      case 'fcc':
        return t(`${PRE_ORIGINAL}-FCC`)
      case 'center':
        return t(`${PRE_ORIGINAL}-CENTER`)
      case 'forest':
        return t(`${PRE_ORIGINAL}-FOREST`)
      case 'micro':
        return t(`${PRE_ORIGINAL}-MICRO`)
      case 'nanny':
        return t(`${PRE_ORIGINAL}-NANNY`)
      case 'ministry':
        return t(`${PRE_ORIGINAL}-MINISTRY`)
      case 'exempt':
        return t(`${PRE_ORIGINAL}-EXEMPT`)
      case 'other':
      default:
        return t(`${PRE_ORIGINAL}-OTHER`)
    }
  }

  return (
    <div data-pendo="selectedProgramTypesFilterButton">
      <FilterControl
        isActive={isActive}
        label={label()}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
